<template>
  <v-card class="rounded-lg white">
    <span v-show="false">{{title}}</span>
    <income-statement-tabs :has-detailed="hasFeature('DETAILED_INCOME_STATEMENT_REPORT')"
                           :detailed="detailed" v-show="!isDialog"></income-statement-tabs>
    <v-card-text>
      <v-row class="mt-5">
        <v-col cols="12" md="2" v-if="detailed">
          <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              class="rounded-lg"
              label="سطح حساب"
              v-model="filters.level"
              item-text="text"
              item-value="value"
              :items="accountLevels"
              :return-object="false"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              class="rounded-lg"
              :items="accountStatuses"
              v-model="filters.status"
              label="وضعیت حساب"
          />
        </v-col>
        <v-col cols="12" md="2">
          <date placeholder="از تاریخ" v-model="filters.from_date"/>
        </v-col>
        <v-col cols="12" md="2">
          <date placeholder="تا تاریخ" v-model="filters.to_date"/>
        </v-col>
        <v-col cols="12" md="2">
          <v-switch
              class="mt-2"
              inset
              color="primary"
              v-model="filters.skip_closing_sanads"
              label='در نظر نگرفتن سند بستن'
          ></v-switch>

        </v-col>

        <v-col cols="12" md="2">
          <v-btn @click="getData()" depressed class="success white--text w-100px mt-1 rounded-lg">گزارش</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="d-flex justify-end">
          <v-btn
              icon
              :href="this.endpoint('reports/newIncomeStatement/html') +
               `?detailed=${detailed == true}${passed_filters}&token=${token}`"
              target="_blank"
              depressed
              class="secondary--text export-btn  mr-md-2 ">
            <v-img max-height="22" max-width="22" src="/img/icons/print_icon.svg"></v-img>
          </v-btn>
          <v-btn
              :href="this.endpoint('reports/newIncomeStatement/pdf') +
               `?detailed=${detailed == true}${passed_filters}&token=${token}`"
              target="_blank"
              icon
              depressed
              class="secondary--text export-btn  mr-md-2"
          >
            <v-img max-height="22" max-width="22" src="/img/icons/pdf.svg"></v-img>
          </v-btn>

          <v-btn
              :href="this.endpoint('reports/newIncomeStatement/xlsx') +
               `?detailed=${detailed == true}${passed_filters}&token=${token}`"
              target="_blank"
              icon
              depressed
              class="secondary--text export-btn  mt-sm-0 mr-md-2 ">
            <v-img max-height="18" max-width="16" src="/img/icons/xls.svg"></v-img>
          </v-btn>

        </v-col>
      </v-row>

        <v-col cols="12" v-if="!detailed">
          <v-simple-table class="rounded-lg">
            <thead class="tableHeader">
            <tr>
              <th class="secondary--text">ردیف</th>
              <th class="secondary--text">شرح</th>
              <th class="text-center secondary--text">مبلغ</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(r, i) in rows">
              <tr :key="i">
                <td>{{ i + 1 }}</td>
                <td :class="{'font-weight-bold': i == rows.length-1}">
                    <span :class="{'error--text': r.type.prefixColor == 'red', 'info--text': r.type.prefixColor == 'blue'}"
                          v-if="r.type.hasPrefix">{{ r.type.prefix }}</span>{{ r.type.name }}</td>
                <td :class="{'font-weight-bold': i == rows.length-1, 'text-center': true}" dir="ltr">
                  {{ r.remain | toMoney }}
                </td>
              </tr>
            </template>
            </tbody>
          </v-simple-table>
        </v-col>




        <v-col cols="12" v-if="detailed">
          <v-simple-table class="rounded-lg">
            <thead class="back">
            <tr>
              <th>ردیف</th>
              <th>شرح</th>
              <th class="text-center">مبلغ</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(r, i) in rows">
              <tr :key="i">
                <td>{{ i + 1 }}</td>

                <td :class="{'font-weight-bold': i == rows.length-1}">
                    <span
                        :class="{'red--text': r.type.prefixColor == 'red', 'blue--text': r.type.prefixColor == 'blue'}"
                        v-if="r.type.hasPrefix"
                    >{{ r.type.prefix }}</span>
                  {{ r.type.name }}
                </td>
                <td :colspan="(detailed)?2:1"
                    :class="{'font-weight-bold': i == rows.length-1, 'text-center': true}"
                    dir="ltr"
                >
                </td>
              </tr>

              <template v-if="detailed">
                <template v-for="(acc, j) in r.accounts">
                  <tr :key="i + '' + j">
                    <td></td>
                    <td class="account-row">{{ acc.title }}</td>
                    <td class="text-center">{{ acc.remain | toAbs | toMoney}}</td>
                  </tr>
                </template>
                <tr :key="'s' + i">
                  <td></td>
                  <td class="account-row">جمع {{ r.type.name }}</td>
                  <td
                      :class="{'text-bold': i == rows.length-1, 'text-center': true}"
                      dir="ltr"
                  >{{ r.remain | toMoney }}
                  </td>
                </tr>
              </template>
            </template>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import date from "@/components/mcomponents/cleave/Date";
import accountApiMixin from "@/mixin/accountMixin";
import IncomeStatementTabs from "@/views/panel/incomeStatement/incomeStatementTab";

export default {
  name: "IncomeStatement",
  components: {IncomeStatementTabs, date},
  props: {
    detailed: {
      default: false
    },
    isDialog: {
      default: false
    }
  },
  data() {
    return {
      rows: [],
      filters: {level: 3, status: 'with_transaction', skip_closing_sanads: false},
      accountStatuses: [
        {value: "all", text: "همه"},
        {value: "with_remain", text: "حساب های دارای مانده"},
        {value: "with_transaction", text: "حساب های دارای گردش"},
      ],
      accountLevels: [
        {value: 1, text: "کل"},
        {value: 2, text: "معین"},
        {value: 3, text: "تفضیلی"},
      ],


    };
  },
  created() {
    this.getData();
  },
  updated() {
    if (this.$route.params.detailed) {
      this.detailed = true
    }

  },
  methods: {
    getData() {
      let filters = {};
      for (const k of Object.keys(this.filters)) {
        if (["undefined", ""].includes(this.filters[k])) return;
        if (k.includes("date") || k.includes("due")) {
          let gDate = this.toGDate(this.filters[k]);
          if (gDate == "Invalid date") {
            this.notify("فرمت تاریخ وارد شده معتبر نمی باشد", "danger");
            return;
          }
          filters[k] = gDate;
        } else {
          filters[k] = this.filters[k];
        }
      }

      return this.request({
        url: this.endpoint("reports/newIncomeStatement"),
        method: "get",
        params: {
          ...this.filters
        },
        success: data => {
          this.rows = data;
        }
      });
    }
  },
  computed: {
    title(){
      if (this.detailed){
        return this.setDocumentTitle('صورت سود و زیان جزئی')
      } else {
        return this.setDocumentTitle('صورت سود و زیان کلی')
      }
    },
    passed_filters() {
      let filters = '';
      filters += '&status='
      filters += this.filters.status
      filters += '&level='
      filters += this.filters.level
      if (this.filters.from_date) {
        filters += '&from_date='
        filters += this.filters.from_date
      }
      if (this.filters.to_date) {
        filters += '&to_date='
        filters += this.filters.to_date
      }
      return filters
    }
  }
};
</script>

<style scoped lang="scss">
.account-row {
  padding-right: 30px;
}
</style>
